import React from 'react';

import MyApplicationPage from "containers/MyApplicationPage";
import WaTemplate from 'containers/WaTemplate';
import CreateTemplateWa from 'containers/WaTemplate/CreateTemplate';
import CompanyDataFirstPage from "containers/MyApplicationPage/CompanyDataFirstPage";
import CreateApplicationPage from "containers/MyApplicationPage/CreateApplicationPage";
// import EditApplicationPage from "containers/MyApplicationPage/EditApplicationPage";
import DetailApplicationPage from "containers/MyApplicationPage/DetailTransactionPage";
import DashboardPage from "containers/DashboardPage";
import DetailAppNew from 'containers/MyApplicationPage/DetailAppNew';
import WhatsappTemplate from 'containers/NewWaTemplate';
import FormCreateTeamplate from 'containers/NewWaTemplate/CreateTemplate/FormCreateTemplate';
import EditAppNew from 'containers/MyApplicationPage/EditAppNew';
import GenerateReport from "../containers/GenerateReport";

export const routes = [
  {
    path:'/',
    component: <MyApplicationPage />,
    exact : true,
    isLayout: true,
    isProtect : true
  },
  {
    path:'/my-application',
    component: <MyApplicationPage />,
    exact : true,
    isLayout: true,
    isProtect : true
  },
  {
    path:'/my-application/create-application',
    component: <CreateApplicationPage />,
    exact : true,
    isLayout: true,
    isProtect : true
  },
  {
    path:'/my-application/edit-application',
    component: <EditAppNew />,
    exact : true,
    isLayout: true,
    isProtect : true
  },
  {
    path:'/my-application/detail-transaction/:id',
    component: <DetailApplicationPage />,
    exact : true,
    isLayout: true,
    isProtect : true
  },
  {
    path:'/my-application/detail/:appId',
    component: <DetailAppNew />,
    exact : true,
    isLayout: true,
    isProtect : true
  },
  {
    path:'/dashboard',
    component: <DashboardPage />,
    exact : true,
    isLayout: true,
    isProtect : true
  },
  {
    path:'/generate-report',
    component: <GenerateReport />,
    exact : true,
    isLayout: true,
    isProtect : true
  },
  {
    path:'/whatsapp-template',
    component: <WaTemplate />,
    exact : true,
    isLayout: true,
    isProtect : true
  },
  {
    path:'/whatsapp-template/create',
    component: <CreateTemplateWa />,
    exact : true,
    isLayout: true,
    isProtect : true
  },
  {
    path:'/whatsapp-template/edit/:id',
    component: <CreateTemplateWa />,
    exact : true,
    isLayout: true,
    isProtect : true
  },
  {
    path:'/company-data-first',
    component: <CompanyDataFirstPage />,
    exact : true,
    isLayout: true,
    isProtect : true
  },
  {
    path:'/new-whatsapp-template',
    component: <WhatsappTemplate />,
    exact : true,
    isLayout: true,
    isProtect : true
  },
  {
    path:'/new-whatsapp-template/create',
    component: <FormCreateTeamplate />,
    exact : true,
    isLayout: true,
    isProtect : true
  },
  {
    path:'/new-whatsapp-template/edit/:id',
    component: <FormCreateTeamplate />,
    exact : true,
    isLayout: true,
    isProtect : true
  },
]